import { useState } from 'react'
import { Link, useLocation, useParams } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import type { ReferralAttribution } from '@manaro/contracts'
import { ReferralOwner } from '@/features/referrals/components/referral-owner.tsx'
import { RevertDialog } from '@/features/referrals/components/revert-dialog.tsx'
import { DEFAULT_REFERRAL_FILTERS, referralsListPath } from '@/features/referrals/filters.ts'
import { useReferral } from '@/features/referrals/use-referrals.ts'
import { ApiError } from '@/shared/api/client.ts'
import { Card } from '@/shared/ui/card.tsx'
import { ErrorState, Skeleton } from '@/shared/ui/states.tsx'

export function ReferralOwnerPage() {
  const { code = '' } = useParams()
  const { state } = useLocation()
  const owner = useReferral(code)
  const [reverting, setReverting] = useState<ReferralAttribution | null>(null)

  const backPath =
    typeof state?.back === 'string'
      ? `/referrals${state.back}`
      : referralsListPath({ ...DEFAULT_REFERRAL_FILTERS, ownerType: owner.data?.ownerType ?? 'business' })

  return (
    <>
      <Link
        to={backPath}
        className="mb-4 inline-flex items-center gap-1.5 text-[13.5px] text-ink-muted transition-colors hover:text-ink max-md:-mt-3 max-md:mb-1 max-md:py-3"
      >
        <ArrowLeft className="size-4" aria-hidden />
        Рефералы
      </Link>

      {owner.isPending ? (
        <div className="flex flex-col gap-3.5">
          <Skeleton className="h-9 w-72" />
          <Skeleton className="h-4 w-96" />
          <Skeleton className="h-[84px] rounded-card" />
          <Skeleton className="h-[280px] rounded-card" />
        </div>
      ) : owner.error ? (
        <Card>
          <ErrorState
            message={owner.error instanceof ApiError ? owner.error.message : 'Не удалось открыть реферальный код.'}
            onRetry={owner.error instanceof ApiError && owner.error.status === 404 ? undefined : () => void owner.refetch()}
          />
        </Card>
      ) : (
        <ReferralOwner owner={owner.data} onRevert={setReverting} />
      )}

      {reverting && owner.data && (
        <RevertDialog
          key={reverting.id}
          attribution={reverting}
          code={owner.data.code}
          onClose={() => setReverting(null)}
        />
      )}
    </>
  )
}
